import { useRef } from "react";
import { motion, useInView } from "framer-motion";

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('framer-motion').Variant} Variant
 * @typedef {import('framer-motion').Transition} Transition
 * @typedef {import('framer-motion').UseInViewOptions} UseInViewOptions
 *
 * @typedef {Object} InViewProps
 * @property {ReactNode} children
 * @property {Object.<string, Variant>} [variants]
 * @property {Transition} [transition]
 * @property {UseInViewOptions} [viewOptions]
 */

/**
 * @type {Object.<string, Variant>}
 */
const defaultVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

/**
 * @param {InViewProps} props
 * @returns {JSX.Element}
 */
export function InView({
  children,
  className,
  variants = defaultVariants,
  transition,
  viewOptions,
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, viewOptions);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={variants}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
}
